import * as Reflux from "reflux";
export const CartSearchActions = {
	onInputChange: Reflux.createAction(["onInputChange"]),
	onNextPage: Reflux.createAction(["onNextPage"]),
	onCustomerSelected: Reflux.createAction(["onCustomerSelected"]),
};
